import { CREATE_INVOICE, GET_INVOICES, GET_INVOICE, UPDATE_INVOICE, DELETE_INVOICE, INVOICE_ERROR} from '../ActionTypes/invoiceVActionTypes';
  
  const initialState = {
    invoices: [],
    currentInvoice: null,
    loading: true,
    error: null
  };
  
  const invoiceVReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_INVOICES:
        return {
          ...state,
          invoices: action.payload,
          loading: false
        };
      case GET_INVOICE:
        return {
          ...state,
          currentInvoice: action.payload,
          loading: false
        };
      case CREATE_INVOICE:
        return {
          ...state,
          invoices: [action.payload, ...state.invoices],
          loading: false
        };
      case UPDATE_INVOICE:
        return {
          ...state,
          invoices: state.invoices.map(invoice => 
            invoice._id === action.payload._id ? action.payload : invoice
          ),
          loading: false
        };
      case DELETE_INVOICE:
        return {
          ...state,
          invoices: state.invoices.filter(invoice => invoice._id !== action.payload),
          loading: false
        };
      case INVOICE_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false
        };
      default:
        return state;
    }
  };
  
  export default invoiceVReducer;
  